var app = angular.module('leonardo');

var StatusFilter = function (ReportService) {
  return function (option) {
    if (!isNull(option)) {
      switch (option.toString()) {
        case ReportService.STATUS_PENDING:
          return 'Pending';
        case ReportService.STATUS_SOLVED:
          return 'Solved';
        case ReportService.STATUS_CANNOT_DO:
          return 'Cannot Do';
      }
    }
    return 'Invalid status';
  };
};

app.filter('status', ['ReportService', StatusFilter]);
